<div [id]="(docTalkObj?.section_name).replace(' ','') +'-'+docCardObj?.product_type_id" class="position-relative webinar-card" [ngClass]="{ 'webinar-card-border' : (callingfrom !== this.mls.googleEventText.grandround.category)&&(callingfrom !== callingScreenName.COMMUNITY_DETAILS)}">
    <div class="position-absolute w-100 h-100 rounded-corner-12 masking-div"
      *ngIf="docCardObj?.channel?.content_visibility?.display==0 || docCardObj?.channel?.content_visibility?.display==2 || docCardObj?.hl?.mcnt">
      <app-product-masking-card
        [content_visibility]="docCardObj?.channel?.content_visibility" [communityVisible]="docCardObj?.hl?.mcnt">
      </app-product-masking-card>
    </div>
    <div>
      <div class="cursor-pointer" (click)="fcs.stopEventPropagation(); navigatetodetail(docCardObj)"
        >
        <div class="row">
          <div [ngClass]="{'col-12': listLength>0, 'col-6': listLength==0}">
            <div class="overflow-hidden position-relative"
              [ngClass]="{'mb-2': docCardObj?.product_type == productType.WEBINAR || (docCardObj?.product_type == productType.CME && (this.mls.featureOnOffList.featureList.cme.value || !mls.userLoginFlow)) }">
              <img *ngIf="docCardObj?.product_type==27" [src]="docCardObj?.banner | fitInImg :igs.imageGroup.fitin_500x500"
                style="width: 100%;
                height: 150px;
                border-top-right-radius: 12px;
                border-top-left-radius: 12px;
                -o-object-fit: scale-down;
                object-fit: scale-down;
                -o-object-position: center;
                object-position: center;
                background-color: #444242;"
                [ngClass]="{'border-radius-0px': callingfrom === this.mls.googleEventText.grandround.category}"
                onerror="this.src='assets/themes/icons/webinar-placeholder.svg'" />
              <img *ngIf="docCardObj?.product_type==8" [src]="docCardObj?.banner_url | fitInImg :igs.imageGroup.fitin_500x500"
                class="webinar-card-banner"
                [ngClass]="{'border-radius-0px': callingfrom === this.mls.googleEventText.grandround.category}"
                onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" />
            </div>
          </div>
          <div
              [ngClass]="{ 'px-3' : callingfrom === this.mls.googleEventText.grandround.category,'px-4' : callingfrom != this.mls.googleEventText.grandround.category, 'col-12': listLength>0, 'col-6': listLength==0,'webinar-card-content-upcoming': !(docCardObj?.views != 0 && docCardObj?.views != null),'webinar-cardcontent': docCardObj?.views != 0 && docCardObj?.views != null }">
            <div class="row webinar-card-content-upcoming">
              <div class="col-10" *ngIf="docCardObj?.product_type==27">
                <div>
                  <p class="mb-2" [ngClass]="callingfrom === this.mls.googleEventText.grandround.category ? 'paragraph-bold' : 'secondary-paragraph'">
                    <span [id]="docTalkSection  + docCardObj?.title +'-'+docCardObj?.webinar_id" class="font-weight-600 webinar-heading">{{docCardObj?.title}}</span></p>

                  <p *ngIf="docTalkSection=='upcoming_Webinar' " class="mb-2 primary-small">
                    <span class="color-grey-700 webinar-release">
                      {{mls.languageText.webinar_card.key7}}
                      <span *ngIf="mls?.is_lskey_display==1">(webinar_card.key7)</span>

                      {{(docCardObj?.release_on*1000) | getDateTimeOnTimezone: docCardObj.timezone: 'DWT'}}
                      {{docCardObj.timezone}}
                    </span>
                  </p>
                </div>
                <p *ngIf="docTalkSection=='upcoming_Webinar' ||docTalkSection == 'you_may_like' || docTalkSection == 'features_videos' || callingfrom =='view_all'"
                  class="primary-small  webinar-speciality">
                  <span class="color-grey-500 pr-2" (click)="fcs.stopEventPropagation(); getFeedTagDetails(speciality)"
                    *ngFor="let speciality of docCardObj?.speciality">
                    #{{speciality?.speciality_name}}
                  </span>
                </p>
              </div>

              <div class="col-10" *ngIf="docCardObj?.product_type==8">
                <p class="paragraph-bold">{{docCardObj?.course_name}}</p>
                <p class="primary-small">
                  <span class="color-grey-700">
                    {{mls.languageText.event_schedule.key9}} {{docCardObj?.expiry_date | date}}
                  </span>
                </p>
              </div>


              <div *ngIf="docCardObj?.product_type==27" class="col-2 pl-0 text-right">
                <app-ngb-drop-down (click)="fcs.stopEventPropagation();" *ngIf="(this.mls.featureOnOffList.featureList.report.value || !mls.userLoginFlow) &&( listLength>1 || callingfrom == mls.googleEventText.webinar_list.category)" [ngbDDL]="ngbDDL"
                  (resetNgbDDLRecord)="resetNgbDDLRecord($event)" [callingFrom]="callingFrom"></app-ngb-drop-down>
              </div>

            </div>
            <div class="col-12">
              <div class="row justify-content-center py-2" *ngIf="webinarStatus.UPCOMING === docCardObj.status && (calledFrom || callingfrom === createRepostScreen || callingfrom === createStoryScreen)">
                <div class="col-7 px-0 pr-0 cursor-default">
                  <p class="secondary-paragraph">{{mls.languageText.webinar_card.key11}}</p>
                  <span class="secondary-paragraph-bold">
                    {{(docCardObj.release_on*1000) | date: 'd MMMM y, h:mm a' : docCardObj.timezone }},
                    {{docCardObj.timezone}}
                  </span>
                </div>
                <div
                  class="col-5 d-flex align-items-center justify-content-end px-0">
                  <ng-container
                    *ngIf="docCardObj.notify_me_flags.registered_button.is_registered === numberConstant.ZERO; else registeredBtn">
                    <button type="button" class="btn-design filled  small h-auto" [ngClass]="{'w-100': callingfrom === createStoryScreen }" (click)="fcs.stopEventPropagation(); notifyMe(docCardObj)"
                    >
                      <span *ngIf="apiInprogess" class="spinner-border spinner-border-sm text-light" role="status"
                        aria-hidden="true"></span>
                      <ng-container *ngIf="!apiInprogess">
                        <img src="assets/themes/icons/white-bell.svg" width="20" />
                        <span>
                          {{docCardObj.notify_me_flags.registered_button.notify_me_buton_text}}
                        </span>
                      </ng-container>
                    </button>
                  </ng-container>

                  <ng-template #registeredBtn>
                    <button type="button" class="btn-design filled-disabled small"[ngClass]="{'w-100': callingfrom === createStoryScreen }" disabled>
                      <img src="/assets/img/akar-check-icon.svg" />
                      <span>
                        {{docCardObj.notify_me_flags.registered_button.notify_me_buton_after_click}}
                      </span>
                    </button>
                  </ng-template>
                </div>
              </div>
            </div>

            <p class="primary-small pb-2"
              *ngIf="docCardObj?.views != 0 && docCardObj?.views != null ">
              <span
                *ngIf="docTalkSection =='end_webinar' || docTalkSection == 'live_webinar'  || docTalkSection == 'features_videos'"
                class="color-grey-700 mr-4 position-relative">
                <span class="color-grey-700"
                  *ngIf="docTalkSection !='live_webinar'  || docTalkSection == 'features_videos' ">{{docCardObj?.views}}</span>
                <span class="color-grey-700" *ngIf="docTalkSection =='live_webinar' "> {{docCardObj?.live_user_string}} </span>
                <span class="color-grey-700" *ngIf="docTalkSection == 'end_webinar'  || docTalkSection == 'features_videos' ">
                  {{mls.languageText.webinar_card.key1}}
                  <span *ngIf="mls?.is_lskey_display==1">(webinar_card.key1)</span>
                </span>
              </span>
            </p>
          </div>
        </div>

        <!-- speakers card -->
        <div class="border clearfix p-2 rounded cursor-pointer webinar-speaker-card" *ngIf="docTalkSection=='top_speakers'"
          (click)="navigateToSpeakerdetail(docCardObj?.id)">
          <div class="float-left mr-2 webinar-speaker-header">
            <img src="" class="post-pic user-40 rounded-circle"
              onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'" />
          </div>
          <div class="float-left webinar-speaker-content">
            <p class="paragraph-bold">{{docCardObj?.name}}</p>
            <p class="primary-small">
              <span class="color-grey-700 mr-4 position-relative">
                {{docCardObj?.speciality_name}}
              </span>
            </p>
          </div>
        </div>
        <!-- speciality card -->
        <div class="position-relative webinar-speciality-card" *ngIf="docTalkSection=='speciality'"
          (click)="fcs.stopEventPropagation(); navigatetospeciality(docCardObj.speciality_id)">
          <div class="position-absolute speciality-card-wrapper w-100 h-100 cursor-pointer rounded" [id]="'speciality-'+docCardObj?.speciality_id">
            <div class="position-absolute speciality-card-text w-100 text-center logo-wrapper">
              <img [src]= "docCardObj?.logo | fitInImg :igs.imageGroup.fitin_500x500" onerror="this.src='assets/themes/icons/banner-placeholder.svg'" width="32" height="32" class="centered-logo"/>
              <p class="pt-2 paragraph-bold">
                <span>{{docCardObj?.speciality_name}}</span></p>
              <p class="secondary-paragraph"><span class="color-grey-700">{{docCardObj?.videoCount}} {{mls.languageText.webinar_card.key3}}<span
                  *ngIf="mls?.is_lskey_display==1">(webinar_card.key3)</span></span></p>
            </div>
          </div>
        </div>
      </div>


      <div class="text-center"
        *ngIf="listLength === numberConstant.ONE && calledFrom">
        <div class="separator-line pb-3"></div>
        <div class="row">
          <div class="col-12 d-flex justify-content-between px-3">
            <p *ngIf="docCardObj?.views > 0 &&  docTalkSection !='live_webinar'" class="secondary-paragraph">
              <span class="color-grey-500">{{docCardObj?.views}} {{mls.languageText.webinar_card.key1}}</span>
              <span *ngIf="mls?.is_lskey_display==1">(webinar_card.key1)</span>
            </p>
            <p *ngIf="this.mls.featureOnOffList.featureList.repost.value || !mls.userLoginFlow">
              <app-repost-popover *ngIf="showRepostPopOver" 
                [isInfoModalShown]="true"
                (emitStartRequest)="closeRepostTooltip()"
                (emitHideModal)="closeRepostTooltip()"
                [screenName]="screenName">
              </app-repost-popover>
              <span  (click)="$event.stopPropagation();generateMeta()"class="cursor-pointer button">
                <img width="22px" class="mr-2" src="assets/themes/icons/repost.svg" alt="icon-repost">
                <span class="color-grey-700">{{mls.languageText.webinar_card.key12}}</span>
                <app-repost-type-list-meta *ngIf="isMetaGenerated" [productId]="docCardObj?.product_type_id" (closeToolTip)="closeMeta($event)" (emitRepostType)="repostWebinarType($event)"></app-repost-type-list-meta>
              </span>
            </p>
            <p *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow">
              <span
                (click)="fcs.stopEventPropagation(); productShare( docCardObj.share,docCardObj.product_type,docCardObj.product_type_id)"
                class="button cursor-pointer">
                <img src="assets/themes/icons/share.svg" alt="share" class="mr-2"/>
                <span class="color-grey-700">{{mls.languageText.webinar_card.key4}}</span>
                <span *ngIf="mls?.is_lskey_display==1">(webinar_card.key4)</span>
              </span>
            </p>
            
            <app-ngb-drop-down  *ngIf="(this.mls.featureOnOffList.featureList.report.value || !mls.userLoginFlow)"
              (click)="fcs.stopEventPropagation();"
              [callingfrom]="callingfrom"
              [ngbDDL]="singlengbDDL"
              (resetNgbDDLRecord)="resetNgbDDLRecord($event)">
            </app-ngb-drop-down>
          </div>
        </div>
      </div>
      <div class="mt-2 d-none border-top" *ngIf="callingfrom !== calledFrom">
        <div class="row ">
          <div class="col-4 text-center pt-2 pb-2">
            <span class="primary-small cursor-pointer " (click)="fcs.stopEventPropagation(); productLike()">
              <!-- loader  -->
              <img *ngIf="feed_like_loader==true" src="assets/themes/images/primary-loader.gif" alt="loader" width="20">
              <img *ngIf="docCardObj?.is_like != 1 && feed_like_loader==false" src='assets/themes/icons/like-white.svg' alt="like">
              <img *ngIf="docCardObj?.is_like == 1 && feed_like_loader==false" src='assets/themes/icons/like-black.svg' alt="like">

              <span class="color-grey-700">
                {{mls.languageText.webinar_card.key6}}
              </span>
              <span *ngIf="mls?.is_lskey_display==1">(webinar_card.key6)</span></span>
          </div>
          <div class="col-4 text-center pt-2 pb-2">
            <span class="primary-small cursor-pointer" (click)="fcs.stopEventPropagation(); productBookmark()">
              <!-- loader  -->
              <img *ngIf="feed_bookmark_loader==true" src="assets/themes/images/primary-loader.gif" alt="loader" width="20">
              <!-- bookmarked -->
              <img *ngIf="docCardObj?.is_bookmarks!=1 && feed_bookmark_loader==false" src='assets/themes/icons/bookmark-white.svg'alt="bookmark">
              <img *ngIf="docCardObj?.is_bookmarks==1 && feed_bookmark_loader==false" src='assets/themes/icons/bookmark-black.svg' alt="bookmark">

              <span class="color-grey-700">
                {{mls.languageText.webinar_card.key5}}
              </span>
              <span *ngIf="mls?.is_lskey_display==1">(webinar_card.key5)</span></span>
          </div>
          <div class="col-4 text-center pt-2 pb-2">
            <span class="primary-small cursor-pointer"
              (click)="fcs.stopEventPropagation(); productShare( docCardObj.share,docCardObj.product_type,docCardObj.product_type_id)"
              >
              <img src="assets/themes/icons/share.svg" alt="share">
              <span class="color-grey-700">
                {{mls.languageText.webinar_card.key4}}
              </span>
              <span *ngIf="mls?.is_lskey_display==1">(webinar_card.key4)</span></span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="consentService.isConsentFormOpen && docCardObj.webinar_id === consentService.productTypeId"
      [config]="{ show: (consentService.isConsentFormOpen && docCardObj.webinar_id === consentService.productTypeId), backdrop: 'static' }"
      (onHidden)="onConsentHidden()" bsModal #autoShownModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
      aria-hidden="true">
      <div class="custom-theme-modal modal-dialog modal-dialog-centered modal-lg" role="form">
        <div class="modal-content">
          <div class="modal-body">
            <app-dynamic-form [isConsentButtonDisabled]="isConsentButtonDisabled"
              [countryCodes]="consentService.countryCodes" [disclaimer]="docCardObj.notify_me_flags.consent.message"
              [formData]="consentService.formData" [label]="consentService.label"
              [consentErrorValidationMsg]="consentErrorValidationMsg" (emitSubmit)="consentSubmit($event)"
              (emitReset)="onConsentHidden()"></app-dynamic-form>
          </div>
        </div>
      </div>
    </div>
  </div>
